import axios from 'axios'

export const BASE_URL = '/app-dashboard'
//export const BASE_URL = 'http://44.220.154.149'

axios.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Token ${token}`
    // if request is not to login and we dont have a token, we should redirect to login
  }
  return config
})

axios.interceptors.response.use(
  (response) => response,
  (config) => {
    if (config.response.data.detail === 'Invalid token.') {
      sessionStorage.removeItem('token')
      window.location.href = '/login'
      return config
    }
    return config
  }
)
